import { useMediaQuery } from 'react-responsive';
import { Box, IconButton, Pagination } from '@99designs/emu';
import { breakpoints } from '@99designs/emu/settings';
import { IconLeft1, IconRight1 } from '@99designs/icons';
import { defaultRenderPageCounter, mobileRenderPageCounter } from './renderPageCounter';

export interface DesignPaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (targetPage: number) => void;
}

export function DesignPagination({ currentPage, totalPages, onPageChange }: DesignPaginationProps) {
    const isMobile = useMediaQuery({ maxWidth: breakpoints.small[1] });
    const desktopRenderPageCounter = defaultRenderPageCounter(onPageChange);

    return (
        <Box display="flex" justifyContent="center" paddingTop="2bu" paddingBottom="6bu">
            <Pagination
                aria-label="pagination"
                currentPage={currentPage}
                href={(pageNumber) => `#${pageNumber}`}
                renderPreviousNavigator={() => (
                    <IconButton
                        aria-label={__placeholder('Previous Page')}
                        icon={IconLeft1}
                        size="medium"
                        appearance="transparent"
                        id="pagination-previous"
                        onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
                    />
                )}
                renderNextNavigator={() => (
                    <IconButton
                        aria-label={__placeholder('Next Page')}
                        icon={IconRight1}
                        size="medium"
                        appearance="transparent"
                        id="pagination-next"
                        onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
                    />
                )}
                renderPageCounter={isMobile ? mobileRenderPageCounter : desktopRenderPageCounter}
                totalPageCount={totalPages}
                width={['fill', 'auto', 'auto']}
            />
        </Box>
    );
}
